export default "__VITE_ASSET__Dr5o26gi__"